module.exports = "<div class=\"container\">\r\n  <div class=\"container-grid\">\r\n    <div class=\"height-75-vh\">\r\n      <ag-grid-angular [gridOptions]=\"gridOptions\">\r\n      </ag-grid-angular>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/billed/summary-grid/summary-grid.component.html
// module id = 2384
// module chunks = 66